import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import qs from 'query-string';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';

import { logging, logPostInfo } from '../../../actions/log';
import RichText from '../../../components/Forum/RichText/RichText';
import Text from '../../../components/Forum/Text/Text';
import CheckSoft from '../../../components/Forum/CheckSoft/CheckSoft';
import Login from '../../../components/Forum/Login/Login';
import ForumBar from '../ForumBar/ForumBar';
import styles from './ForumPublish.module.less';
import { GUIDE_CONTENT } from '../../../constants/forum';
import Btn from '../../../components/Btn/Btn';
import Dialog from '../../../components/Dialog/Dialog';
import { createAxios } from '../../../utils/utils';
import { FORUM_SUBMIT_72, FORUM_CONTENT_72, CONTEXT } from '../../../config';
import Toast from '../../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function ForumPublish() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const { type = '1', id = null } = qs.parse(search);
  const { refresh, drop, dropScope } = useAliveController();

  const logInfoData = useSelector(selectLogInfo);

  const [richTextNode, setRichTextNode] = useState(null);
  const [textNode, setTextNode] = useState(null);
  const [checkSoftList, setCheckSoftList] = useState([]);
  const [showDialog, setShowDialog] = useState(false); // 是否展示弹窗
  const [loginStatus, setLoginStatus] = useState(false);
  const [loginPanel, setLoginPanel] = useState(false);
  const [textValidate, setTextValidate] = useState(null);
  const [richtextValidate, setRichtextValidate] = useState(null);
  const [defaultValue, setDefaultValue] = useState({}); // 页面的默认值
  const [hasPublish, setHasPublish] = useState(false);

  const [initTime, setInitTime] = useState(+new Date());

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Forum_Publish`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Forum_Publish',
        label: '',
        param2: {
          source: 'Forum_Publish',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type,
          id,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Forum_Publish',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });
  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
  }, []);
  useActivate(() => {
    pagePvLog();
  });

  useEffect(() => {
    if (!loginStatus) {
      setLoginPanel(true);
    }
  }, []);
  useActivate(() => {
    if (!loginStatus) {
      setLoginPanel(true);
    }
  });

  const getForumDetail = async () => {
    const axios = await createAxios('isNeedUser');
    const res = await axios.get(FORUM_CONTENT_72, {
      params: {
        id,
      },
    });
    try {
      if (res && res.data && res.data.status === 0) {
        const { passInfos, text, title } = res.data.data;
        setCheckSoftList(passInfos);
        textNode.value = title;
        richTextNode.txt.html(text);
        setDefaultValue({
          title,
          html: text,
          checkSoftList: passInfos,
        });
      }
    } catch (err) {}
  };
  useEffect(() => {
    if (id && textNode && richTextNode) {
      getForumDetail();
    }
  }, [id, textNode, richTextNode]);
  const handleCloseDialog = visible => () => {
    setShowDialog(visible);
  };

  const handleValidateForumContent = () => {
    if (!loginStatus) {
      setLoginPanel(true);
      return;
    }
    if (textValidate || richtextValidate) {
      Toast.error({
        content: textValidate || richtextValidate,
      });
      return;
    }
    // eslint-disable-next-line consistent-return
    return true;
  };

  const handelPublish = async () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Forum_Publish_Submit',
        label: '',
        param2: {
          source: 'Forum_Publish',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          passInfos: checkSoftList,
          id: id || '',
          type: GUIDE_CONTENT[type].type, // 页面类型
        },
      }),
    );

    setHasPublish(true);
    const validateResult = handleValidateForumContent();
    if (!validateResult) {
      return; // 验证不通过
    }
    setHasPublish(false);
    const title = textNode.value;
    const desc = richTextNode.txt.html();
    const forumPublishParams = {
      id,
      type: GUIDE_CONTENT[type].type, // 页面类型
      title,
      text: desc,
      passInfos: checkSoftList,
    };
    const axios = await createAxios('isNeedUser');
    const publishResult = await axios.post(FORUM_SUBMIT_72, forumPublishParams);
    try {
      dispatch(
        logging({
          category: 'R',
          action: 'Forum_Publish_Submit',
          label: '',
          param2: {
            source: 'Forum_Publish',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            status: publishResult && publishResult.data && publishResult.data.status,
          },
        }),
      );
      if (publishResult.data.status === 0) {
        Toast.success({
          content: '帖子提交成功',
        });

        // 发表成功后清除页面缓存，并跳入发表页面
        drop('forumPublish');
        drop('forumlistpublish');
        setTimeout(() => {
          const URL = `${CONTEXT}/forumlistpublish`;
          history.push(URL);
        }, 50);
      }
    } finally {
      if (
        !publishResult ||
        !publishResult.data ||
        !publishResult.data.status ||
        publishResult.data.status !== 0
      ) {
        Toast.error({
          content:
            (publishResult && publishResult.data && publishResult.data.message) || '发表失败',
        });
      }
    }
  };

  useEffect(() => {
    if (loginStatus && hasPublish) {
      handelPublish();
    }
  }, [loginStatus, hasPublish]);

  const handelCancelPublish = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Forum_Publish_Cancel',
        label: '',
        param2: {
          source: 'Forum_Publish',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    history.push(`${CONTEXT}/forumlist`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.forum_bar}>
        <ForumBar />
      </div>
      <div className={styles.type}>我要{GUIDE_CONTENT[type].desc}</div>
      <div className={styles.title}>
        <div className={styles.title_text}>
          标题<div className={styles.required_icon}>*</div>
        </div>
        <Text
          className={styles.title_input}
          placeholder={GUIDE_CONTENT[type].title}
          initText={r => setTextNode(r)}
          maxLen={50}
          maxLenTipStyle={styles.maxTitleLenTip}
          validate={res => {
            setTextValidate(res);
          }}
          validateInfo={{
            required: '发表失败，请填写标题',
            size: '请将标题字数控制在50字以内',
          }}
          required
          defaultValue={defaultValue.title}
        />
      </div>
      <div className={styles.desc}>
        <div className={styles.desc_text}>
          描述<div className={styles.required_icon}>*</div>
        </div>
        <RichText
          height={222}
          placeholder={GUIDE_CONTENT[type].text}
          initRichText={r => setRichTextNode(r)}
          maxLen={1500}
          validate={res => {
            setRichtextValidate(res);
          }}
          validateInfo={{
            required: '发表失败，请输入描述',
            size: '请将描述字数控制在1500字以内',
          }}
          required
          defaultValue={defaultValue.html}
        />
      </div>
      <div className={styles.soft}>
        <div className={styles.soft_text}>相关软件</div>
        <div className={styles.soft_checksoft}>
          <CheckSoft
            setCheckSoftList={setCheckSoftList}
            checkSoftList={checkSoftList}
            pageKey={'comment'}
          />
        </div>
      </div>
      <div className={styles.btn}>
        <div className={styles.btn_cancel}>
          <Btn className={styles.btn_cancel_el} handleClick={handelCancelPublish}>
            取消
          </Btn>
        </div>
        <div className={styles.btn_publish}>
          <Btn
            className={`${styles.btn_publish_el}  ${
              textNode && textNode.value && richTextNode && richTextNode.txt.html()
                ? ''
                : styles.btn_publish_el_disable
            }`}
            primary
            handleClick={() => {
              if (textNode && textNode.value && richTextNode && richTextNode.txt.html()) {
                handelPublish();
              }
            }}
          >
            发表
          </Btn>
        </div>
      </div>
      {showDialog && (
        <Dialog
          title="温馨提示"
          maskStyle={styles.mask}
          containerStyle={styles.mask_container}
          handleClose={handleCloseDialog(false)}
        >
          <div className={styles.mask_content}>
            <div className={styles.mask_desc}>退出后您编辑的内容不会被保存，是否退出？</div>
            <div className={styles.mask_p_btn}>
              <Btn
                primary
                className={styles.mask_btn}
                handleClick={() => {
                  history.push(`${CONTEXT}/forumlist`);
                }}
              >
                确定
              </Btn>
              <Btn className={styles.mask_btn} handleClick={handleCloseDialog(false)}>
                取消
              </Btn>
            </div>
          </div>
        </Dialog>
      )}
      <Login
        getLoginStatus={state => setLoginStatus(state)}
        callLoginPanel={loginPanel}
        resetLoginPanel={() => {
          setLoginPanel(false);
        }}
      />
    </div>
  );
}

export default () => {
  const {
    location: { href },
  } = window;
  return (
    <KeepAlive name="forumPublish" id={href}>
      <ForumPublish />
    </KeepAlive>
  );
};
